import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { ArrowDownToLine } from "lucide-react";

interface IStarterType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function StarterType(props: IStarterType) {
    const { value, onChange, loading } = { ...props };
    const [starterType, setStarterType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setStarterType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setStarterType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Starter Type
            </Typography>

            <Select
                placeholder="Select starter type"
                value={starterType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<ArrowDownToLine size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Universal Starter">Universal Starter</Option>
                <Option value="Laminated Double Layer">Laminated Double Layer</Option>
            </Select>
        </Box>
    );
}
